export const DATE_FORMAT_TASKS_SINGLE_VOYAGE = 'DD.MM.YYYY HH:mm'
